import { Link } from '@flos/react-ui';
import Currency from '../Currency/Currency';
import { useState } from 'react';
import IncludedPriceModal from '../PriceTaxModal/IncludedPriceModal';
import { useHippoText } from '../../hooks/useHippoText';
import './TotalPrice.css';

const TotalPrice = ({
    totalPrice = 0,
    showYearlyPriceField,
    paymentFrequencyPostfix,
    displayTaxesSubtitle = false,
    overrideLabel,
    shouldRenderShoppingBasketDesign = false,
    shouldShowPriceIncludingTaxes = false,
    isCVR = false,
    showCarTaxes = true,
    showTaxesOnlyForLob
}: {
    totalPrice?: number;
    showYearlyPriceField: boolean;
    paymentFrequencyPostfix: string;
    displayTaxesSubtitle?: boolean;
    overrideLabel?: string;
    shouldRenderShoppingBasketDesign?: boolean;
    shouldShowPriceIncludingTaxes?: boolean;
    isCVR?: boolean;
    showCarTaxes?: boolean;
    showTaxesOnlyForLob?: string;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const yearlyPrice = totalPrice * 12;
    const [showModal, setShowModal] = useState(false);
    const totalPriceLabelCvrOrCpr = isCVR
        ? getHippoText('DSS-COMMON-TOTAL-PRICE-CVR')
        : getHippoText('DSS-COMMON-TOTAL-PRICE');
    const totalPriceLabel = overrideLabel ?? totalPriceLabelCvrOrCpr;
    const taxesSubtitle = getHippoText('DSS-SHOPPING-BASKET-INCLUDED-IN-PRICE');

    return (
        <>
            {shouldRenderShoppingBasketDesign ? (
                <span className="u-flex-box u-flex-box--col u-gap-3">
                    <span className="u-flex-box u-flex-box--center u-flex-box--space-between u-flex-box--no-gap u-flex-box--nowrap">
                        <h4 className="strong u-spacing-stack-bottom-none">{totalPriceLabel}</h4>
                        <h4 className="strong u-spacing-stack-bottom-none u-text-right price-label-margin">
                            <Currency
                                price={totalPrice}
                                paymentFrequencyPostfix={paymentFrequencyPostfix}
                            />
                        </h4>
                    </span>
                    <span className="u-flex-box u-flex-box--center u-flex-box--space-between u-flex-box--no-gap u-flex-box--nowrap">
                        <Link
                            className={
                                'paragraph--medium u-spacing-stack-none u-color-primary-2-base textlink-weight-update'
                            }
                            theme="logo"
                            onClick={() => {
                                setShowModal(true);
                            }}
                        >
                            {taxesSubtitle}
                        </Link>

                        {showYearlyPriceField && (
                            <p className="paragraph--medium u-spacing-stack-bottom-none u-text-right price-label-margin yearly-price-weight">
                                <Currency
                                    price={yearlyPrice}
                                    paymentFrequencyPostfix={getHippoText('DSS-COMMON-YEAR')}
                                />
                            </p>
                        )}
                    </span>
                </span>
            ) : (
                <div className={'u-spacing-inset-m--stretch-max'}>
                    <div className={'u-flex-box u-flex-box--space-between u-flex-box--nowrap'}>
                        <h4 className={'u-spacing-stack-s'}>
                            {overrideLabel ??
                                getHippoText(
                                    isCVR ? 'DSS-COMMON-TOTAL-PRICE-CVR' : 'DSS-COMMON-TOTAL-PRICE'
                                )}
                        </h4>
                        <h4 className={'u-spacing-stack-s u-text-right'}>
                            <Currency
                                price={totalPrice}
                                paymentFrequencyPostfix={paymentFrequencyPostfix}
                            />
                        </h4>
                    </div>
                    <div className={'u-flex-box u-flex-box--space-between u-flex-box--nowrap'}>
                        {displayTaxesSubtitle ? (
                            <Link
                                className={
                                    totalPrice === 0
                                        ? 'paragraph--medium u-spacing-stack-none u-color-primary-2-base u-color-supplement-grey-medium'
                                        : 'paragraph--medium u-spacing-stack-none u-color-primary-2-base'
                                }
                                onClick={() => {
                                    if (totalPrice === 0) return;
                                    setShowModal(true);
                                }}
                            >
                                {taxesSubtitle}
                            </Link>
                        ) : (
                            <div />
                        )}
                        {showYearlyPriceField && (
                            <p
                                className={
                                    'paragraph--medium u-spacing-stack-none u-text-right yearly-price-weight'
                                }
                            >
                                <Currency
                                    price={yearlyPrice}
                                    paymentFrequencyPostfix={getHippoText('DSS-COMMON-YEAR')}
                                />
                            </p>
                        )}
                    </div>
                </div>
            )}
            {showModal && (
                <IncludedPriceModal
                    showModal={showModal}
                    shouldShowPriceIncludingTaxes={shouldShowPriceIncludingTaxes}
                    closeModal={() => {
                        setShowModal(false);
                    }}
                    isCVR={isCVR}
                    showCarTaxes={showCarTaxes}
                    showTaxesOnlyForLob={showTaxesOnlyForLob}
                />
            )}
        </>
    );
};

export default TotalPrice;
